import { JSX, useState } from "react";

enum ViewTypeEnum {
    list = "list",
    map = "map",
}
interface IGenderIndexMobileView {
    listUi?: JSX.Element;
    mapUi?: JSX.Element;
}
function GenderIndexMobileView({ listUi, mapUi }: IGenderIndexMobileView) {
    const [selectedView, setSelectedView] = useState(ViewTypeEnum.list);
    return (
        <div className="genderIndexMobileView">
            <div className="groupBtn">
                <button
                    className={`btn ${selectedView === ViewTypeEnum.list ? "active" : ""}`}
                    onClick={() => setSelectedView(ViewTypeEnum.list)}>
                    List view
                </button>
                <button
                    className={`btn ${selectedView === ViewTypeEnum.map ? "active" : ""}`}
                    onClick={() => setSelectedView(ViewTypeEnum.map)}>
                    Chart view
                </button>
            </div>
            <div className='tableChartWrapper'>
                {
                    selectedView === ViewTypeEnum.list && listUi
                }
                {
                    selectedView === ViewTypeEnum.map && mapUi
                }
            </div>
        </div>
    );
}

export default GenderIndexMobileView;
